import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from "react-redux";
import * as actions from "./../../actions";

import Grid from '@material-ui/core/Grid';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ListItemIcon from '@material-ui/core/ListItemIcon';

import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";

import ArrowRightIcon from '@material-ui/icons/ArrowRight';

const styles = theme => ({
  root:{
    display:"flex",
    justifyContent: "center",

  },

  dialog:{
    height: "100vh",
    overlay: "none"
  },



  dialogContent:{


    padding:theme.spacing.unit * 5,
    paddingTop: 50,
  },


  graphContainer:{

    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",

    height: "35vh",

    overflow: "hidden"
  },

  title:{
    fontSize: 40,

    textAlign: "center",
    textTransform: "uppercase"
  },



  /// CLOSE BUTTON
  close:{
    position: "absolute",

    right: 20,
    top: 50
  },
  closeIcon:{
    fontSize: 40,
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}



class UserAgreementDialog extends React.Component {
  state = {

    isOpen: this.props.userAgreementDialog,

  }

  static contextTypes = {
    router: PropTypes.object
  }

  componentDidUpdate(prevProps){

    if(prevProps.userAgreementDialog !== this.props.userAgreementDialog){

      this.setState({isOpen: this.props.userAgreementDialog})
    }
  }



  openDialog = ()=>{
    this.setState({isOpen: true})
  }

  closeDialog = ()=>{
    this.props.callback("CLOSE")

  }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  goToPayment = ()=>{
    this.context.router.history.push(`/narocilo/${this.props.product.id}`)
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Dialog
          fullScreen
          open={this.state.isOpen}
          onClose={this.closeDialog}
          TransitionComponent={Transition}
        >
          <div className={classes.root} >

            <Grid container className={classes.dialog} justify="center">
              <Grid item xs={12} sm={10} className={classes.dialogContent}>

                  <Typography variant="title" className={classes.title}>
                    SPLOŠNI POGOJI UPORABE
                  </Typography>
                  <List >
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ti pogoji določajo pravice in obveznosti Bet Moneymakerja (v nadaljevanju: ponudnik) ter njegovih strank (v nadaljevanju: uporabniki).

                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Uporaba oziroma branje vsebin, ki ji ponudnik objavlja na svojih spletni strani oziroma na njenih podstraneh, je dopustna samo poslovno sposobnim fizičnim osebam.

                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik uporabnike vljudno vabi, da pogoje preberejo oziroma preučijo.
                          Z vstopom na katero koli spletno mesto ponudnika uporabniki potrjujejo in soglašajo, da so s temi pogoji uporabe seznanjeni ter da jih zavezujejo.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik si bo prizadeval, da bo spletno mesto delovalo nemoteno, vendar pa za kakršne koli pomanjkljivosti ne odgovarja in jih ni dolžan pojasnjevati uporabnikom.

                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>

                          Ponudnik ni odškodninsko oziroma drugače odgovoren za pomanjkljivosti na spletni strani oziroma na njenih pod-straneh.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik ni odškodninsko oziroma drugače odgovoren za pomanjkljivosti na spletni strani oziroma na njenih pod-straneh.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>

                          Ponudnik uporabnike poučuje, da dejanski in končni rezultati s športnih tekmovanj, glede katerih je ponudnik analiziral in napovedal rezultate, ponudnik ne garantira.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Analize in napovedi ponudnik objavlja dnevno, pet krat na teden in po svoji izbiri glede dneva. Ponudnik se lahko kadar koli odloči, da bo prenehal z analizami in napovedmi.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik svojim uporabnikom omogoča vpogled v analize in napovedi rezultatov s športnih tekmovanj, ki so tudi plačljive (v nadaljevanju: plačljive vsebine).
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik uporabnike opozarja, da plačljive vsebine ne pomenijo za ponudnika nobeno obveznost rezultata.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik bo uporabnike v določenih intervalih statistično obveščal o uspehih svojih napovedi rezultatov s športnih tekmovanj.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          V primeru športnega dogodka, ki se je začel in se ne odigra v roku 72 ur je napoved stornirana.
                          To velja predvsem pri teniških dogodkih, kjer eden od dvobojevalcev dvoboj preda.
                          Ne glede na to kateri igralec napreduje je v vsakem primeru ta dvoboj storniran.
                          Enako velja pri košarkarskih in nogometnih napovedih kadar pride do izgreda in se dvoboj prekine.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Vpogled v plačljive vsebine je mogoč šele po tem, ko ponudnik uporabniku potrdi uporabniško ime (UI) in geslo (G) za vpogled v plačljive vsebine.
                          Ponudnik uporabniku UI in G potrdi po plačilu zneska, ki je objavljen na spletni strani ponudnika.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik fizičnim osebam, ki niso poslovno sposobne, oziroma, ki so stare manj kot 18 let, UI in G v nobenem primeru ne potrdi.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Za pridobitev UI in G je uporabnik dolžan podati resnične in pravilne podatke, ki jih ponudnik zahteva pri pridobivanju UI in G.
                          Rubrike navedene z oznako »*« so obvezne.
                          S podatki, ki se nanašajo na uporabnike, bo ponudnik ravnal v skladu s predpisi, ki veljajo oziroma se uporabljajo v Republiki Sloveniji.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Uporabnik mora UI in G hranit varno ter ga v nobenem primeru ne sme posredovati tretji osebi.
                          Ponudnik uporabnike opozarja, da se s potrjenim UI in G lahko do ponudnikovih plačljivih vsebin dostopa s tistega IP naslova računalnika,
                          ki je bil uporabljen ob potrditvi UI in G. V primeru dostopa z drugega IP naslova računalnika bo ponudnik onemogočil dostop do plačljivih vsebin.
                          V primeru, da se uporabniku dostop do plačljivih vsebin odvzame mu ponudnik ni dolžan vrniti članarine.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik uporabnike poučuje, da so analize in napovedi avtorsko pravno zaščitene. V primeru kakršne koli zlorabe, kot npr. kopiranje,
                          objavljanje v kakršni koli obliki, raznašanje tretjim osebam, bo ponudnik zoper kršitelja ustrezno ukrepal.
                          V primeru, da se uporabniku dostop do plačljivih vsebin odvzame mu ponudnik ni dolžan vrniti članarine.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Spletno mesto ponudnika lahko vsebujejo povezave do strani, ki so v imetništvu tretjih oseb.
                          Ponudnik nad temi spletnimi mesti nima nadzora in nikakršnega vpliva.
                          Ponudnik uporabnikom svetuje, da si na vsaki od teh strani preberete pogoje uporabe.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ponudnik bo v vseh primerih kršenja pogojev oziroma povzročitve kakršne koli škode ponudniku sprožil ustrezne pravne postopke.
                          Za sodno reševanje sporov je v vsakem primeru pristojno slovensko sodišče, ki uporablja slovensko pravo.
                        </Typography>
                      </ListItem>
                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <ArrowRightIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          Ti pogoji veljajo in se uporabljajo od 21.3.2010 do spremembe.
                          V primeru sprememb oziroma dopolnitev bo ponudnik od uporabnikov zahteval ponovno potrditev o soglašanju s pogoji.
                        </Typography>
                      </ListItem>
                  </List>

              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" onClick={()=> this.props.showUserAgreementDialog(false)} color="primary" fullWidth> NAZAJ </Button>
              </Grid>
            </Grid>
          </div>
        </Dialog>
      </div>
    );
  }
}

UserAgreementDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

const mapStateToProps = ({userAgreementDialog}) => {
  return {
    userAgreementDialog
  }
}

export default connect(mapStateToProps, actions)( withStyles(styles, { withTheme: true })(UserAgreementDialog))



// WEBPACK FOOTER //
// ./src/components/reusableComponents/UserAgreementDialog.js